import { fetchInvoice } from '@pages/page-account-receivable/page-invoice/action';
import { IStateReducer } from '@reducers/state';
import { connect } from 'react-redux';
import PageInvoiceDetailComponent from './component';

export const mapStateToProps = (state: IStateReducer) => ({
  isFetching: state.DefaultReducer.isFetching,
  metaData: state.DefaultReducer.metaData,
  invoice: state.PageAccountReceivableReducer.invoice,
});

export const mapDispatchToProps = (dispatch: any) => ({
  fetchInvoice: (code: string) => dispatch(fetchInvoice(code)),
});

export const PageInvoiceDetailContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageInvoiceDetailComponent);

export default PageInvoiceDetailContainer;
